module.exports = __webpack_public_path__ + "static/screenie_drag_video_static-099b7a85895f97e036c1d9771113b409.jpg";